import React from 'react'
import {
  ContainerOnlyBigScreens,
  ContainerOnlySmallScreens
} from 'styles/common/Common.styles'
import FooterDesktop from './FooterDesktop'
import { StyledBottomNavigation } from './FooterDesktop.styles'
import { useFooter } from './Footer.hooks'
import { useLocation } from 'react-router-dom'
import { ADMIN_ROOT_PATH_MOBILE } from 'routes/paths'
import { useSyncMobileFooterHeightCssVar } from './useSyncMobileFooterHeightCssVar'
import { useTranslation } from 'i18n'

const Footer = () => {
  const { renderingItems } = useFooter()
  const { t } = useTranslation()
  const location = useLocation()
  useSyncMobileFooterHeightCssVar()

  if (location.pathname.includes(ADMIN_ROOT_PATH_MOBILE)) {
    return null
  }
  return (
    <React.Fragment>
      <ContainerOnlyBigScreens as="footer">
        <FooterDesktop />
      </ContainerOnlyBigScreens>

      <ContainerOnlySmallScreens
        as="nav"
        id="footer-mobile"
        aria-label={t('Navegação principal')}
      >
        <StyledBottomNavigation items={renderingItems()} />
      </ContainerOnlySmallScreens>
    </React.Fragment>
  )
}

export default Footer
